import { Link } from "react-router-dom";
import "./categories.css";


const categories = [

{
name:"Baby",
path:"/category/Baby",
image:"https://i.postimg.cc/XND0s4yH/baby.jpg",
},


{
name:"Girls",
path:"/category/Girls",
image:"https://i.postimg.cc/W45tbxhG/Whats-App-Image-2026-07-30-at-10-48-14-PM.jpg",
},


{
name:"Boy",
path:"/category/Boy",
image:"https://i.postimg.cc/Yq7Lp53W/Whats-App-Image-2026-07-30-at-10-48-15-PM.jpg",
},


{
name:"Accessories",
path:"/category/Accessories",
image:"https://i.postimg.cc/FRG8Y5SH/Whats-App-Image-2026-07-30-at-10-48-15-PM-(2).jpg",
},


{
name:"Toys",
path:"/category/Toys",
image:"https://i.postimg.cc/rFyyZMjj/Whats-App-Image-2026-07-30-at-10-48-15-PM-(1).jpg",
},


{
name:"Gifts",
path:"/category/Gifts",
image:"https://i.postimg.cc/YCgP1mgq/Whats-App-Image-2026-07-30-at-10-48-16-PM.jpg",
},


{
name:"Nursery",
path:"/category/Nursery",
image:"https://i.postimg.cc/50PKx5cL/Whats-App-Image-2026-07-30-at-10-48-16-PM-(1).jpg",
},


{
name:"Back to School",
path:"/category/Back-to-School",
image:"https://i.postimg.cc/KcHpw5DK/Whats-App-Image-2026-07-30-at-10-48-16-PM-(2).jpg",
}


];




function Categories(){


return(

<section className="categories-section">


<h2 className="categories-title">
Category Shop
</h2>



<div className="categories">


{
categories.map((cat,index)=>(


<Link

to={cat.path}

className="category-card"

key={index}

>


<img

src={cat.image}

alt={cat.name}

/>


<h3>

{cat.name}

</h3>


</Link>


))


}



</div>


</section>


);


}


export default Categories;